import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('tc-website-projectslist')
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement as HTMLElement)
    root.render(
        <React.StrictMode>
            <App rootElement={rootElement}/>
        </React.StrictMode>
    )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
